import { lazy } from "react";

const registry: Record<string, React.LazyExoticComponent<() => JSX.Element>> = {
  "actual-intelligence": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/project-and-knowledge/actual-intelligence/tabs/overview")
  ),
  "automation-labs": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/automation-solutions/automation-services/tabs/overview")
  ),
  "system-bridge": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/automation-solutions/workflow-automation/tabs/overview")
  ),
  "outage-hub": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/support-and-expertise/outage-hub/tabs/overview")
  ),
  "tech-mentor": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/support-and-expertise/tech-mentor/tabs/overview")
  ),
  "troubleshooting": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/support-and-expertise/troubleshooting/tabs/overview")
  ),
  "client-intelligence": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/operations/client-intelligence/tabs/overview")
  ),
  "vendor-ops": lazy(() =>
    import("../../components/vendor-atlas-ui/tabs/overview")
  ),
  "lifecycle-navigator": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/projects-and-people/employee-lifecycle/tabs/overview")
  ),
  "project-execution": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/project-and-knowledge/project-execution/tabs/overview")
  ),
  "onboarding": lazy(() =>
    import("../../components/pages/dashboard/solutions/pages/project-and-knowledge/onboarding/tabs/overview")
  ),
  "desktop-app": lazy(() =>
    import("../../components/pages/dashboard/desktop-app/tabs/overview")
  ),
};

export function getSolutionOverview(slug: string) {
  return registry[slug] ?? null;
}
